const NoContent = () => {
  return <div className='notFound'>404 NOT FOUND</div>;
};

export default NoContent;
